import React, { useState } from 'react'

import { Card, SimpleGrid } from '@driftt/dds'

import CCRMActivityFeedPage from 'pages/CCRMActivityFeedPage'

import SavedFiltersSidebar from '../SavedFiltersSidebar'

export interface ActivityTabProps {}

const ActivityTab = ({ access, sessionMetrics }: { access: any; sessionMetrics: any }) => {
  const [toastText, setToastText] = useState<string | undefined>()
  return (
    <SimpleGrid
      columns={2}
      gap={4}
      css={{
        height: '100%',
        gridTemplateColumns: '212px 1fr',
        gridTemplateRows: '100% calc(100% - $8)'
      }}>
      <SavedFiltersSidebar toastText={toastText} setToastText={setToastText} />
      <Card css={{ height: 'calc(100% - $8)', marginTop: '$4', overflow: 'hidden', padding: 0 }}>
        <CCRMActivityFeedPage hasSidebar={false} sessionMetrics={sessionMetrics} />
      </Card>
    </SimpleGrid>
  )
}

export default ActivityTab
